import DrawerSimple from "ds/components/DrawerNew/Simple";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerBody from "ds/components/Drawer/Body";
import DrawerFooter from "ds/components/Drawer/Footer";
import DrawerFooterActions from "ds/components/Drawer/FooterActions";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import DrawerCancelButton from "ds/components/DrawerNew/CancelButton";
import { PermissionMetadata } from "shared/Actions/types";

import PermissionsTable from "./PermissionsTable";

type PreviewPermissionsDrawerProps = {
  roleName: string;
  permissions: PermissionMetadata[];
};

const PreviewPermissionsDrawer = createDrawer<PreviewPermissionsDrawerProps>(
  ({ roleName, permissions }) => {
    return (
      <DrawerSimple variant="wide" isDismissable>
        <DrawerHeader justify="between">
          <DrawerHeaderTitle title="Preview permissions" />
          <DrawerCloseIcon />
        </DrawerHeader>
        <DrawerBody>
          <PermissionsTable
            permissions={permissions}
            ariaLabel={`Permissions for ${roleName} role`}
          />
        </DrawerBody>
        <DrawerFooter sticky>
          <DrawerFooterActions>
            <DrawerCancelButton text="Close" />
          </DrawerFooterActions>
        </DrawerFooter>
      </DrawerSimple>
    );
  }
);

export const showPreviewPermissionsDrawer = createDrawerTrigger(PreviewPermissionsDrawer);
